import { PersonalDiscountedVariant } from 'api/product/getPersonalizedProductDetails/types';
import LazyMotionWrapper from 'components/lazy-motion-wrapper';
import { ProductDetailsHeaderProvider } from 'modules/product-details/components/product-details-header/state';
import React from 'react';
import ProductDetails from './product-details';
import { ProductDetailsProvider } from './state';
import { ProductDetailsPage } from './types';

type Props = {
  initialVariantId?: ProductDetailsPage['initialVariantId'];
  interval: ProductDetailsPage['interval'];
  productDetails: ProductDetailsPage['productDetails'];
  defaultPriceVariants: PersonalDiscountedVariant[];
};

const ProductDetailsWrapper: React.FC<Props> = ({
  initialVariantId,
  interval,
  productDetails,
  defaultPriceVariants,
}) => {
  return (
    <ProductDetailsHeaderProvider
      defaultPriceVariants={defaultPriceVariants}
      initialVariantId={initialVariantId}
      interval={interval}
      productDetails={productDetails}
    >
      <ProductDetailsProvider productDetails={productDetails}>
        <LazyMotionWrapper>
          <ProductDetails />
        </LazyMotionWrapper>
      </ProductDetailsProvider>
    </ProductDetailsHeaderProvider>
  );
};

export default ProductDetailsWrapper;
